import { Divider } from '@mui/material';
import React from 'react';
import { V } from '../Layout';
import FilterDisplay from '../components/FilterDisplay';

const RenderFilterPreview =
    (
        groupedFilters: Record<string, string[]>,
        toLabel: (identifier: string) => string,
        isTitleVisible: boolean = true
    ) =>
    () => (
        <V gap={1}>
            {isTitleVisible && <FilterDisplay groupedFilters={groupedFilters} toLabel={toLabel} />}
            <Divider sx={{ width: '100%' }} />
        </V>
    );

export default RenderFilterPreview;
